import { render, staticRenderFns } from "./FollowUpPatientStep10Component.vue?vue&type=template&id=4d3bbcf0&scoped=true&"
import script from "./FollowUpPatientStep10Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep10Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep10Component.vue?vue&type=style&index=0&id=4d3bbcf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3bbcf0",
  null
  
)

export default component.exports